import Router, {useRouter} from 'next/router'
import dynamic from 'next/dynamic'
import React, {useEffect, useState} from "react";
import StockSummary from "../../components/summary/StockSummary";
import axios from "../../components/plugins/axios";
import Error from "../_error";
import HistoryChart from "../../components/stock/HistoryChart";
import {callIranMarketStockSummaryAPI, fetchStockSummary} from "../../util/APIUtils";
import {makeStockHelmet} from "../../util/SEOUtil";
import Box from "../../components/box/Box";
import {parseIranMarketApiResponse} from "../../util/DominantUtil";

const HistoryChartDynamic = dynamic(() =>
        import('../../components/stock/HistoryChart'),
    {ssr: false})

const TVChartContainer = dynamic(
    () =>
        import('../../components/tradingView/TVChartContainer').then(mod => mod.default),
    {ssr: false},
);

export default function Stock({stockSummary}) {

    function iframe() {
        const iframe = `<iframe id='tradingview_ffde0' instanceId='${stockSummary.insCode}' src='https://api.bahabin.com/technical/tsev2/script/charting_library/static/tv-chart.html?localserver=1&symbol=35425587644337450&interval=D&toolbarbg=f4f7f9&studies=&enabledStudies=%5B%5D&enabledDrawings=%5B%5D&disabledDrawings=%5B%22Regression%20Trend%22%5D&overrides=%7B%7D&locale=fa' style="width: 100%; height: 100%; margin: 0 !important; padding: 0 !important;" allowtransparency="true" scrolling="no" width="100%" height="100%" frameborder="0"></iframe>`;
        return (<div className="col-xl-12 col-lg-12 col-md col-sm" style={{
            width: '100%',
            minHeight: '600px',
            padding: '0 !important'
        }} dangerouslySetInnerHTML={{__html: iframe}}/>);
    }

    const market = "بورس"

    return (
        <Box disableHeader={true} loaded={true} leftBoxClassName={'bg-white w-100'}
             height={1150}
             showRW={true}>
            {stockSummary && makeStockHelmet({
                market: market,
                assetType: 'سهام',
                faN: stockSummary.s,
                s: stockSummary.cn
            })}
            <div className="stock-box p-20px">
                <div className="stock-box row">
                    <div className="stock-summary col-xl-5 col-lg-5 col-md col-sm">
                        <StockSummary data={stockSummary}/>
                    </div>
                    <div className="stock-history-chart col-xl-7 col-lg-7 col-md col-sm">
                        <HistoryChartDynamic symbol={stockSummary.s}/>
                    </div>
                </div>
                <div className="technical-chart">
                    <TVChartContainer symbol={stockSummary.s} has_no_volume={true}/>
                </div>
                {/*<SupportResistanceChart symbol={stock}/>*/}
            </div>
        </Box>
    );
}

export async function getServerSideProps(context) {
    const {stock} = context.query;
    const response = await fetchStockSummary("IRFM:" + stock);

    if (response.length === 0) {
        return {
            notFound: true,
        };
    }

    const stockSummary = parseIranMarketApiResponse(response)[0];

    return {
        props: {
            stockSummary
        },
    };
}
